import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Corporate from './pages/Corporate';
import Accessories from './pages/Accessories';
import BespokeSuiting from './pages/BespokeSuiting';
import WeddingTailoring from './pages/WeddingTailoring';
import OurStory from './pages/OurStory';
import VisitStore from './pages/VisitStore';
import Navigation from './components/navigation/Navigation';
import Footer from './components/footer/Footer';
import TopBar from './components/topbar/TopBar';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col bg-background-light dark:bg-background-dark text-text-main-light dark:text-text-main-dark">
        <ScrollToTop />
        <TopBar />
        <Navigation />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/corporate" element={<Corporate />} />
            <Route path="/accessories" element={<Accessories />} />
            <Route path="/bespoke-suiting" element={<BespokeSuiting />} />
            <Route path="/weddingtailoring" element={<WeddingTailoring />} />
            <Route path="/our-story" element={<OurStory />} />
            <Route path="/visit-store" element={<VisitStore />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
